export const PREFIX = 'MD-ANNUAL_PLAN_';

export const REFRESH_CONTENT = PREFIX + 'REFRESH_CONTENT';
export const SEARCH_REFRESH = PREFIX + 'SEARCH_REFRESH';
